import type { RawParams } from "@uirouter/core";

import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import {
    isJacoRecording,
    isJacoRunning,
    setRecordingStatus,
    startJacoRecorder,
    stopJacoRecorder,
} from "app/services/plugins/JacoPlugin";
import { openSurvey, registerSurveyListeners } from "app/services/plugins/WebEngagePlugin";
import {
    allTrackers,
    googleTracker,
    healthChecks,
    intercomTracker,
    matomoTracker,
    mixpanelTracker,
    munchkinTracker,
} from "app/services/track/track";

import { registerToonimoListeners } from "./plugins/ToonimoPlugin";

async function trackPageViewWithCustomUrl(toState: IRouterState, toParams: RawParams): Promise<void> {
    await allTrackers.trackPageViewWithCustomUrl(toState, toParams);
}

function init() {
    registerSurveyListeners();
    registerToonimoListeners();
}

export const SwTrack = {
    google: googleTracker,
    matomo: matomoTracker,
    munchkin: munchkinTracker,
    intercom: intercomTracker,
    mixpanel: mixpanelTracker,
    all: allTrackers,
    healthChecks,
    trackPageView: trackPageViewWithCustomUrl,
    isJacoRunning,
    isJacoRecording,
    startJacoRecorder,
    stopJacoRecorder,
    setRecordingStatus,
    openSurvey,
    get buffer() {
        return matomoTracker.getTrackers()[0].getBuffer();
    },
    init,
};
